import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import Field from '@/packages/field';
import DictApi from '@/api/dict';
import { InfoComplementField } from '../../types';

const style = require('./index.module.scss') as Dictionary;

@Component({ name: 'Profession' })
export default class Profession extends Vue implements InfoComplementField {
  @Prop()
  private value!: undefined | number;

  private profession: undefined | number | null = null;

  private errorMsg = '';

  private created() {
    if (this.value) {
      this.profession = this.value;
    }
  }

  @Watch('value')
  private onValueChange(val: undefined | number) {
    if (val !== this.profession) {
      this.profession = val;
    }
  }

  public onValidator(): boolean {
    if (this.profession === undefined || this.profession === null) {
      this.errorMsg = '请选择职业';
      return false;
    }

    return true;
  }

  private onChangeProfession(val: number | undefined | null) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private render() {
    return (
      <div class={style.Profession}>
        <Field
          v-model={this.profession}
          label="职业"
          sub={true}
          type="select"
          onChange={() => this.onChangeProfession(this.profession)}
          dictApi={DictApi.getProfessionType}
          error={this.errorMsg}
          readonly={true}
        />
      </div>
    );
  }
}
